// `GET /v1/audit-log` — read-only surface over the existing generic
// `AuditLog` table (see `apps/api/prisma/schema.prisma`), built for the
// teacher student-detail "Access log" tab (rebuild of the removed
// `/v1/access-grants*`-backed tab — see
// `apps/web/src/views/teacher/TeacherStudentDetailView.vue`'s file header).
// This does NOT introduce new event-capture — it reads rows already written
// by `recordAuditLog`/`writeAuditLog` call sites (`apps/api/src/jobs/payments.ts`,
// `apps/api/src/routes/students.ts`, `apps/api/src/services/studentPackages.ts`,
// `apps/api/src/jobs/expiry.ts`).
//
// `entityType` is allowlisted to what the student-detail page needs — NOT a
// generic browse of the whole `AuditLog` table (P3-05-style scoping
// convention: narrow the read surface to the concrete UI need, don't expose
// the raw table). `entityId` is the id of that specific entity row (e.g. a
// `StudentPackage.id`, NOT a `studentId` — every `entityType: 'StudentPackage'`
// write keys `entityId` off the `StudentPackage` row's own id).
import { z } from 'zod';
import { paginationQuerySchema } from './primitives';

export const AUDIT_LOG_ENTITY_TYPES = ['StudentPackage', 'User'] as const;
export type AuditLogEntityType = (typeof AUDIT_LOG_ENTITY_TYPES)[number];

export const auditLogQuerySchema = paginationQuerySchema.extend({
  entityType: z.enum(AUDIT_LOG_ENTITY_TYPES),
  entityId: z.string().trim().min(1, 'entityId is required'),
});
export type AuditLogQuery = z.infer<typeof auditLogQuerySchema>;
